import React from "react";
import { PeopleGroup } from "@procore/core-icons";
import { Button } from "@procore/core-react";

interface BenchButtonProps {
   isOpen: boolean;
   onToggle: () => void;
}

export function BenchButton({ isOpen, onToggle }: BenchButtonProps) {
   return (
      <Button
         variant="tertiary"
         icon={<PeopleGroup size="sm" />}
         onClick={onToggle}
         className={isOpen ? "controlPanelButtonActive" : ""}
      />
   );
}
